var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgSharePriceArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21,
  height: 21
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "share-price-arrow_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  transform: "translate(1590.318 411.99)",
  fill: "#fff",
  stroke: "#707070",
  d: "M0 0h21v21H0z"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1590.318 -411.99)",
  clipPath: "url(#share-price-arrow_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1592.043 418.376h16.962l-8.481 8.814Z",
  fill: "#fff"
}))));

export default SvgSharePriceArrow;